/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedBlurbReturns_user$ref = any;
export type PdpSharedBlurbReturns_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": PdpSharedBlurbReturns_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedBlurbReturns_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '871381ffb25bb95935181a3c9bb6907a';
export default node;
